import { Component, ReactElement } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { User } from 'models/ui';
import { AppConstant } from 'constants/app.constant';
import { cookieService, featureService } from 'services';
import { appActions, appSelectors } from 'redux/ducks/app';
import { PageHeader, PageLoader } from 'components/common';
import { ELSFlex, ELSFlexItem } from 'components/common/els';
import './instructor.page.wrapper.scss';

export interface InstructorPageWrapperProps {
  children(arg: { loggedInUser: User; userRole: string; intl: IntlShape; isInstructorSaveData: boolean }): ReactElement;
  loggedInUser: User;
  userRole: string;
  title: string;
  intl: IntlShape;
  isInstructorSaveData: boolean;
  setIsInstructorSaveData: Function;
}

class InstructorPageWrapper extends Component<InstructorPageWrapperProps> {
  static displayName = 'InstructorPageWrapper';
  static defaultProps = {
    title: 'SimChart Assignment'
  };
  constructor(props) {
    super(props);
    cookieService.remove(AppConstant.COOKIE_IS_DEMO);
  }

  async componentDidMount() {
    const { setIsInstructorSaveData } = this.props;
    try {
      const isInstructorSaveDataFlag = await featureService.isInstructorSaveDataEnabled();
      setIsInstructorSaveData(isInstructorSaveDataFlag);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('checkFeatureInstructorSaveDataFlag failed:', err);
    }
  }

  render() {
    const { title, loggedInUser, userRole, children, intl, isInstructorSaveData } = this.props;
    return (
      <>
        <PageLoader />
        <div className="instructor-page-wrapper">
          <PageHeader title={title} />
          <ELSFlex>
            <ELSFlexItem grow className="instructor-page-wrapper__content-wrapper">
              {children({ loggedInUser, userRole, intl, isInstructorSaveData })}
            </ELSFlexItem>
          </ELSFlex>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  loggedInUser: appSelectors.getLoggedInUser(state),
  userRole: appSelectors.getUserRole(state),
  isInstructorSaveData: appSelectors.getInstructorSaveData(state)
});

const mapDispatchToProps = (dispatch) => ({
  setIsInstructorSaveData: (flagValue: boolean) => dispatch(appActions.setIsInstructorSaveData(flagValue))
});

const enhancers = [injectIntl, connect(mapStateToProps, mapDispatchToProps)];

export { InstructorPageWrapper as BaseInstructorPageWrapper };
export default compose(...enhancers)(InstructorPageWrapper);
